import { Injectable } from '@angular/core';
import { OneSignalService } from './one-signal.service';
import { WindowService } from './window.service';

const SPRING_LOGOUT_PATH = '/j_spring_security_logout';
const RETURN_URL_QUERY_PARAM = 'oe_sso_redirect_url';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  constructor(
    private readonly oneSignalService: OneSignalService,
    private readonly windowService: WindowService
  ) {}

  logout(returnUrl?: string): void {
    this.oneSignalService.logout();
    this.windowService.redirectToHref(this.buildLogoutUrl(returnUrl));
  }

  private buildLogoutUrl(returnUrl?: string): string {
    if (!returnUrl) {
      return SPRING_LOGOUT_PATH;
    }
    return `${SPRING_LOGOUT_PATH}?${RETURN_URL_QUERY_PARAM}=${encodeURIComponent(returnUrl)}`;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/logout.service.ts